import * as React from 'react';
export const anthropicSvg = React.forwardRef(function anthropicSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D4A27F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.304 7h-3.672l6.696 16.918H28L21.304 7ZM10.696 7 4 23.918h3.744l1.37-3.553h7.005l1.369 3.553h3.744L14.536 7h-3.84Zm-.371 10.223 2.291-5.945 2.292 5.945h-4.583Z',
      fill: '#000',
    }),
  );
});
anthropicSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var anthropic = {
  category: 'brand',
  colorable: false,
  name: 'anthropic',
  svg: anthropicSvg,
};
